import React from "react";
import { useState, useEffect } from 'react';



function CountdownTimer() {
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
  
    useEffect(() => {
      const endDate = new Date('February 11, 2023 16:00:00').getTime();
      const interval = setInterval(() => {
        const currentDate = new Date().getTime();
        const timeLeft = endDate - currentDate;
  
        setDays(Math.floor(timeLeft / (1000 * 60 * 60 * 24)));
        setHours(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        setMinutes(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)));
        setSeconds(Math.floor((timeLeft % (1000 * 60)) / 1000));
      }, 1000);
  
      return () => clearInterval(interval);
    }, []);
  
    return (
      <div className=" text-center justify-center mt-20 m-10 mb-5 rounded-md lg:h-48  ">
        <h1 className=" lg:text-5xl md:text-4xl sm:text-3xl mb-5 mt-7 font-bold text-2xl">Countdown To End Of Hackathon !!!</h1>
        <div className=" lg:mt-12 font-extrabold text-3xl lg:text-6xl md:text-3xl sm:text-3xl" >
          {days} days: {hours} hours: {minutes} minutes: {seconds} seconds
        </div>
      </div>
    );
  }
  
  export default CountdownTimer;
